import { Injectable } from '@angular/core';
import { EditorComponent } from '@tinymce/tinymce-angular';

@Injectable({ providedIn: 'root' })
export class RedactorService {
  #editor: EditorComponent | null = null;

  init(editor: EditorComponent) {
    this.#editor = editor;
  }

  dispose() {
    this.#editor = null;
  }

  print() {
    this.#editor?.editor.execCommand('mcePrint');
  }
}
